export interface Test {
  id: string;
  moduleId: string;
  courseId?: string;
  name: string;
  testType: TestType;
  passingPercentage: number;
  maxAttempts: number;
  timeLimit: number;
  shuffleQuestions: boolean;
  shuffleAnswers: boolean;
  createdAt?: string;
  updatedAt?: string;
}

export enum TestType {
  MODULE_FINAL = 'MODULE_FINAL',
  COURSE_FINAL = 'COURSE_FINAL',
}

export interface TestInput {
  moduleId: string;
  passingPercentage: number;
  maxAttempts?: number;
  timeLimit?: number;
  shuffleQuestions?: boolean;
  shuffleAnswers?: boolean;
  translations: Array<{ locale: 'uz' | 'ru' | 'en'; name: string }>;
}

export enum QuestionType {
  SINGLE_CHOICE = 'SINGLE_CHOICE',
  MULTIPLE_CHOICE = 'MULTIPLE_CHOICE',
}

export interface QuestionOption {
  id?: string;
  text: string;
  isCorrect: boolean;
  image?: string | File | null;
}

export interface Question {
  id?: string;
  text: string;
  type: QuestionType;
  points?: number;
  orderIndex?: number;
  image?: string | File | null;
  options: QuestionOption[];
}

export interface AddQuestionsInput {
  questions: Array<{
    type: QuestionType;
    points?: number;
    image?: string | null;
    translations: Array<{ locale: 'uz' | 'ru' | 'en'; text: string }>;
    options: Array<{
      id?: string;
      isCorrect: boolean;
      translations: Array<{ locale: 'uz' | 'ru' | 'en'; text: string }>;
    }>;
  }>;
}

export interface QuestionUpdateInput {
  type: QuestionType;
  points?: number;
  orderIndex?: number;
  image?: string | null;
  translations: Array<{ locale: 'uz' | 'ru' | 'en'; text: string }>;
  options: Array<{
    id?: string;
    isCorrect: boolean;
    translations: Array<{ locale: 'uz' | 'ru' | 'en'; text: string }>;
  }>;
}
